import React from 'react'

import FlowTargetProvider from './providers/FlowTargetProvider'

import Button from '@SonarCX/components/atoms/Button2'
import CustomFieldsList from '../../CustomFieldsList'
import NoGroups from '../GroupSettings/NoGroups'
import Flow from './Flow'
import NewFlowModal from './NewFlowModal'

import { ObjectType, nameMap } from '../../types'
import useCustomFieldFlows from '@SonarCX/hooks/useCustomFieldFlows'
import useStyles from '../styles'

type FlowSettingsProps = {
  tab: ObjectType
}

const FlowSettings: React.FC<FlowSettingsProps> = ({ tab }) => {
  const { allFlows: flows } = useCustomFieldFlows(tab)

  const [newFlowModalOpen, setNewFlowModalOpen] = React.useState(false)

  const filteredFlows = React.useMemo(() => {
    return flows.slice()
  }, [flows])

  const classes = useStyles()

  return (
    <>
      <div className={classes.container}>
        <div className={classes.list}>
          <div className={classes.controls}>
            <div className={classes.buttonRoot}>
              <Button
                className={classes.button}
                onClick={() => setNewFlowModalOpen(true)}
              >
                + Stage
              </Button>
            </div>
          </div>

          <div className={classes.list}>
            {filteredFlows.length === 0 ? (
              <NoGroups title='flows' />
            ) : (
              <FlowTargetProvider>
                {filteredFlows.map((flow, i) => (
                  <Flow
                    key={flow.id}
                    tab={tab}
                    flow={flow}
                    isFirst={i === 0}
                    isLast={i === filteredFlows.length - 1}
                  />
                ))}
              </FlowTargetProvider>
            )}
          </div>
        </div>

        <CustomFieldsList tab={tab} />
      </div>

      {newFlowModalOpen && (
        <NewFlowModal
          title={nameMap[tab]}
          object_type={tab}
          onClose={() => setNewFlowModalOpen(false)}
        />
      )}
    </>
  )
}

export default FlowSettings
